'use client'

import { useAtom } from 'jotai'

import { OptionTableColumn } from '@/features/chart/lib/configs/option-setting-config'
import { optionTableConfigAtom } from '@/state/chart'

export type OptionTableConfig = {
  columns: OptionTableColumn
  columnsOrder: number[]
}

export function useOptionTableConfig() {
  const [config, setConfig] = useAtom(optionTableConfigAtom)

  const updateColumn = (column: keyof OptionTableColumn, checked: boolean) => {
    setConfig({
      ...config,
      columns: {
        ...config.columns,
        [column]: checked,
      },
    })
  }

  const updateColumnsOrder = (order: number[]) => {
    setConfig({
      ...config,
      columnsOrder: order,
    })
  }

  return {
    columns: config.columns,
    columnsOrder: config.columnsOrder,
    updateColumn,
    updateColumnsOrder,
  }
}
